import React from 'react';

import { IAsset } from 'components/Pages/Admin/shared/ItinerariesItemLanding/Builder/types';
import Modal from 'components/shared/Modal';
import i18n from 'i18n';

import FileUpload from '../AddNewContent/FileUpload';
import { IUploadProps } from '../AddNewContent/Upload/types';
import s from './index.module.css';
import { Item } from './Item';
import { Preview } from './Preview';
import { useDocument } from './useDocument';

const DROPZONE_COUNT = 0;

function Document(props: IUploadProps) {
  const { data } = props;
  const { openModal, setOpenModal, filesLength, files, currentFile, handlePreview } = useDocument(props);

  if (filesLength === DROPZONE_COUNT) {
    return <FileUpload {...props} availableInBasic={data.availableInBasic} />;
  }

  return (
    <div className={s.wrapper}>
      {/*@ts-ignore*/}
      <Modal isOpen={openModal} toClose={() => setOpenModal(false)} size="auto">
        <Preview currentFile={currentFile as IAsset} />
      </Modal>

      <div className={s.title} data-block>
        {i18n.t('proposal_content.file.pdf_documents')}
      </div>

      <div className={s.list}>
        {files.map((file, i) => (
          <Item key={i} file={file} handlePreview={handlePreview} />
        ))}
      </div>
    </div>
  );
}

export default Document;
